/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Recommenderror1Inputs */

const id_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silakan pilih ya atau tidak`)
};

const ms_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sila pilih ya atau tidak`)
};

const da_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg venligst ja eller nej`)
};

const de_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie Ja oder Nein`)
};

const en_us2_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select yes or no`)
};

const es_es2_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecciona sí o no`)
};

const es_mx2_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecciona sí o no`)
};

const fil_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mangyaring pumili ng oo o hindi`)
};

const fr_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez sélectionner oui ou non`)
};

const it_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona sì o no`)
};

const hu_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kérjük, válassz igent vagy nemet`)
};

const nl_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer ja of nee`)
};

const no_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vennligst velg ja eller nei`)
};

const pl_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz tak lub nie`)
};

const pt_br2_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select yes or no`)
};

const pt_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecione sim ou não`)
};

const ro_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te rugăm să selectezi da sau nu`)
};

const fi_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse kyllä tai ei`)
};

const sv_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vänligen välj ja eller nej`)
};

const vi_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng chọn có hoặc không`)
};

const tr_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen evet veya hayır seçin`)
};

const cs_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prosím vyberte ano nebo ne`)
};

const bg_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моля, изберете да или не`)
};

const ru_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите «Да» или «Нет»`)
};

const uk_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Будь ласка, оберіть так або ні`)
};

const ar_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يرجى اختيار نعم أو لا`)
};

const hi_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ या नहीं चुनें`)
};

const th_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรุณาเลือกใช่หรือไม่`)
};

const ja_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はいまたはいいえを選択してください`)
};

const zh_cn2_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select yes or no`)
};

const zh_hant1_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select yes or no`)
};

const ko_forms_review_recommenderror1 = /** @type {(inputs: Forms_Review_Recommenderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select yes or no`)
};

/**
* | output |
* | --- |
* | "Please select yes or no" |
*
* @param {Forms_Review_Recommenderror1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_recommenderror1 = /** @type {((inputs?: Forms_Review_Recommenderror1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Recommenderror1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_recommenderror1(inputs)
	if (locale === "ms") return ms_forms_review_recommenderror1(inputs)
	if (locale === "da") return da_forms_review_recommenderror1(inputs)
	if (locale === "de") return de_forms_review_recommenderror1(inputs)
	if (locale === "en-US") return en_us2_forms_review_recommenderror1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_recommenderror1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_recommenderror1(inputs)
	if (locale === "fil") return fil_forms_review_recommenderror1(inputs)
	if (locale === "fr") return fr_forms_review_recommenderror1(inputs)
	if (locale === "it") return it_forms_review_recommenderror1(inputs)
	if (locale === "hu") return hu_forms_review_recommenderror1(inputs)
	if (locale === "nl") return nl_forms_review_recommenderror1(inputs)
	if (locale === "no") return no_forms_review_recommenderror1(inputs)
	if (locale === "pl") return pl_forms_review_recommenderror1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_recommenderror1(inputs)
	if (locale === "pt") return pt_forms_review_recommenderror1(inputs)
	if (locale === "ro") return ro_forms_review_recommenderror1(inputs)
	if (locale === "fi") return fi_forms_review_recommenderror1(inputs)
	if (locale === "sv") return sv_forms_review_recommenderror1(inputs)
	if (locale === "vi") return vi_forms_review_recommenderror1(inputs)
	if (locale === "tr") return tr_forms_review_recommenderror1(inputs)
	if (locale === "cs") return cs_forms_review_recommenderror1(inputs)
	if (locale === "bg") return bg_forms_review_recommenderror1(inputs)
	if (locale === "ru") return ru_forms_review_recommenderror1(inputs)
	if (locale === "uk") return uk_forms_review_recommenderror1(inputs)
	if (locale === "ar") return ar_forms_review_recommenderror1(inputs)
	if (locale === "hi") return hi_forms_review_recommenderror1(inputs)
	if (locale === "th") return th_forms_review_recommenderror1(inputs)
	if (locale === "ja") return ja_forms_review_recommenderror1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_recommenderror1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_recommenderror1(inputs)
	return ko_forms_review_recommenderror1(inputs)
});
export { forms_review_recommenderror1 as "forms.review.recommendError" }